import { ButtonKey } from '@hb/modules/global/global.constants';
import { AnalyticsClickDirective } from '@hb/directives';

import { Component } from '@angular/core';

import { ApContentModule } from '@ap/content';
import { ApAnalyticsModule } from '@ap/analytics';
import { ApButtonLinkComponent } from '@ap/button';

@Component({
    selector: 'ap-appointment-button',
    templateUrl: './appointment-button.component.html',
    standalone: true,
    imports: [ApContentModule, AnalyticsClickDirective, ApAnalyticsModule, ApButtonLinkComponent]
})
export class AppointmentButtonComponent {
    protected readonly buttonKey = ButtonKey;
}
